var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({staticClass:"ics-number-input",attrs:{"type":"number"},on:{"change":_vm.onChange}},'v-text-field',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }